/** A single-select row of tap chips (scales + dropdown-style picks). Tapping the active one clears it. */
interface SingleSelectProps {
  options: readonly string[];
  value: string | null | undefined;
  onChange: (value: string) => void;
  ariaLabel: string;
}

export function SingleSelect({ options, value, onChange, ariaLabel }: SingleSelectProps) {
  return (
    <div className="chip-row" role="group" aria-label={ariaLabel}>
      {options.map((opt) => {
        const selected = value === opt;
        return (
          <button
            key={opt}
            type="button"
            aria-pressed={selected}
            className={`chip${selected ? ' is-selected' : ''}`}
            onClick={() => onChange(opt)}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
